/**
 * Seleção adaptativa de batch por pressão, rede e bytes.
 */

import type { QueueItem } from '../queue';
import { canBatchTogether } from '../ordering/transactionGroup';

const DEFAULT_MAX_BYTES = 48 * 1024;
const DEFAULT_MAX_COUNT = 50;

export interface AdaptiveBatchOptions {
  maxBytes?: number;
  maxCount?: number;
  queuePressure?: number;
  networkOnline?: boolean;
  circuitOpen?: boolean;
}

export function pickAdaptiveBatch(
  ordered: QueueItem[],
  options: AdaptiveBatchOptions = {}
): QueueItem[] {
  const maxBytes = options.maxBytes ?? DEFAULT_MAX_BYTES;
  let maxCount = options.maxCount ?? DEFAULT_MAX_COUNT;

  if (options.circuitOpen) maxCount = Math.min(maxCount, 5);
  if (options.networkOnline === false) maxCount = Math.min(maxCount, 10);
  if ((options.queuePressure ?? 0) > 0.8) maxCount = Math.min(maxCount, 15);

  const batch: QueueItem[] = [];
  let bytes = 0;

  for (const item of ordered) {
    if (batch.length >= maxCount) break;
    const itemBytes = estimateItemBytes(item);
    if (batch.length > 0 && bytes + itemBytes > maxBytes) break;
    if (batch.length > 0 && !canBatchTogether(batch[0], item)) continue;
    batch.push(item);
    bytes += itemBytes;
  }

  return batch;
}

function estimateItemBytes(item: QueueItem): number {
  try {
    return (
      new TextEncoder().encode(JSON.stringify(item.params.eventData ?? {})).length +
      128
    );
  } catch {
    return 256;
  }
}
